import { Suspense } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouterStore } from 'features/main/main-router/org-guard/RouterStore'
import { Route, Routes } from 'react-router-dom'
import RouteRedirect from './RouteRedirect'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import { themeConfig } from '@gap/shared/theme'
import GapDialog from 'reusable/gap-dialog/GapDialog'

export default observer(function RouteRenderer() {
   const routerStore = useRouterStore()

   return <Routes>
      <Route index element={<RouteRedirect />} />
      {routerStore.routes.map(route => !!route.path && (
         <Route
            key={'route' + route.name}
            path={route.path + (route.exact ? "" : "/*")}
            element={<Suspense fallback={<></>}>
               <Stack sx={{ maxWidth: themeConfig.breakpoints.values.lg, m: '0 auto', height: '100%' }}>
                  {route.renderTitle !== false && <Typography variant="h4" sx={{ color: themeConfig.primary['900'] }}>{route.name}</Typography>}
                  <route.component />
               </Stack>
            </Suspense>}
         />
      ))}
      <Route path={'/*'} element={(
         <GapDialog
            open
            primary={{ name: "Home", callback: () => routerStore.goToNavPath('/') }}
            title='404'>
            Page not found
         </GapDialog>
      )} />
   </Routes>
})
